export const SubmissionAnswerEnum = {
  video: 'VIDEO',
  audio: 'AUDIO',
  text: 'TEXT',
  image: 'IMAGE',
  singleSelect: 'SINGLE_SELECT',
  multipleSelect: 'MULTIPLE_SELECT',
  matchTheFollowing: 'MATCH_THE_FOLLOWING',
  fillInTheBlanks: 'FILL_IN_THE_BLANKS',
  '': 'EMPTY',
  opinionScale: 'OPINION_SCALE',
  file: 'FILE'
};

export default SubmissionAnswerEnum;
